"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function Livestreams() {
    var sports = ra_fetch_1.useApi('backend').index('public.sports')[0];
    var _a = react_1.useState(false), showEvents = _a[0], setShowEvents = _a[1];
    return react_1.default.createElement("div", { className: 'storybook-pages-livestreams' },
        react_1.default.createElement(storybook_1.Layouts.Container, null,
            react_1.default.createElement(storybook_1.Ads.Ad, { className: 'leaderboard-homepage', type: 'leaderboard-billboard' }),
            react_1.default.createElement("div", { className: 'flex justify-center items-center mb-7' },
                react_1.default.createElement("img", { src: process.env.NEXT_PUBLIC_STORYBOOK_CDN_URL + "/front-end/img/live.png", className: 'storybook-pages-livestreams-icon' }),
                react_1.default.createElement("div", { className: 'storybook-pages-livestreams-toggle', onClick: function () { return setShowEvents(false); } },
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2', className: "storybook-pages-livestreams-heading " + (!showEvents ? 'active' : '') }, "Kijk nu live")),
                react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2', className: 'storybook-pages-livestreams-heading px-4' }, "/"),
                react_1.default.createElement("div", { className: 'storybook-pages-livestreams-toggle', onClick: function () { return setShowEvents(true); } },
                    react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2', className: "storybook-pages-livestreams-heading " + (showEvents ? 'active' : '') }, "Agenda"))),
            !showEvents && sports.data.map(function (sport, index) { return react_1.default.createElement(storybook_1.Livestreams.Row, { key: index, sport: sport }); })),
        showEvents && react_1.default.createElement(storybook_1.Events.Calender, null));
}
exports.default = Livestreams;
